// // import React, { useState, useEffect } from "react";
// // import {
// //   Card,
// //   Row,
// //   Col,
// //   Container,
// //   Table,
// //   ProgressBar,
// //   Button,
// // } from "react-bootstrap";
// // import {
// //   FaUsers,
// //   FaDollarSign,
// //   FaCalendarCheck,
// //   FaChartLine,
// //   FaUserPlus,
// //   FaBell,
// //   FaArrowUp,
// //   FaArrowDown,
// // } from "react-icons/fa";
// // import {
// //   LineChart,
// //   Line,
// //   BarChart,
// //   Bar,
// //   PieChart,
// //   Pie,
// //   Cell,
// //   XAxis,
// //   YAxis,
// //   CartesianGrid,
// //   Tooltip,
// //   Legend,
// //   ResponsiveContainer,
// // } from "recharts";
// // import { gymMembersAPI } from "../../api/gymMembers";
// // import { membershipAPI } from "../../api/membershipPlans";
// // import { paymentsAPI } from "../../api/payments";
// // import "./Dashboard.css";

// // const Dashboard = () => {
// //   const [stats, setStats] = useState({
// //     totalMembers: 0,
// //     activeMembers: 0,
// //     monthlyRevenue: 0,
// //     pendingPayments: 0,
// //     newMembersThisMonth: 0,
// //     memberGrowth: 0,
// //     revenueGrowth: 0,
// //   });

// //   const [recentMembers, setRecentMembers] = useState([]);
// //   const [recentPayments, setRecentPayments] = useState([]);
// //   const [loading, setLoading] = useState(true);
// //   const [chartData, setChartData] = useState([]);
// //   const [membershipDistribution, setMembershipDistribution] = useState([]);

// //   const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042", "#8884D8"];

// //   useEffect(() => {
// //     fetchDashboardData();
// //   }, []);

// //   const fetchDashboardData = async () => {
// //     setLoading(true);
// //     try {
// //       // Fetch all data in parallel
// //       const [membersResponse, plansResponse, paymentsResponse] =
// //         await Promise.all([
// //           gymMembersAPI.getMembers(),
// //           membershipAPI.getPlans(),
// //           paymentsAPI.getPayments(),
// //         ]);

// //       const members = membersResponse.data;
// //       const plans = plansResponse.data;
// //       const payments = paymentsResponse.data;

// //       // Calculate stats
// //       const totalMembers = members.length;
// //       const activeMembers = members.filter((m) => m.is_active).length;
// //       const monthlyRevenue = payments.reduce(
// //         (sum, payment) => sum + payment.paid_amount,
// //         0
// //       );
// //       const pendingPayments = plans.filter(
// //         (plan) => plan.status === "pending"
// //       ).length;
// //       const currentMonth = new Date().getMonth();
// //       const newMembersThisMonth = members.filter((member) => {
// //         const joinDate = new Date(member.created_at);
// //         return joinDate.getMonth() === currentMonth;
// //       }).length;

// //       // Calculate growth (simplified - in real app, compare with previous period)
// //       const memberGrowth =
// //         totalMembers > 0
// //           ? ((newMembersThisMonth / totalMembers) * 100).toFixed(1)
// //           : 0;
// //       const revenueGrowth = 15.5; // Example growth percentage

// //       setStats({
// //         totalMembers,
// //         activeMembers,
// //         monthlyRevenue,
// //         pendingPayments,
// //         newMembersThisMonth,
// //         memberGrowth: parseFloat(memberGrowth),
// //         revenueGrowth,
// //       });

// //       // Set recent members (last 5)
// //       setRecentMembers(members.slice(0, 5));

// //       // Set recent payments (last 5)
// //       setRecentPayments(payments.slice(0, 5));

// //       // Prepare chart data for revenue by month
// //       const monthlyData = Array.from({ length: 6 }, (_, i) => {
// //         const date = new Date();
// //         date.setMonth(date.getMonth() - (5 - i));
// //         return {
// //           month: date.toLocaleString("default", { month: "short" }),
// //           revenue: Math.floor(Math.random() * 10000) + 5000,
// //         };
// //       });
// //       setChartData(monthlyData);

// //       // Prepare membership distribution data
// //       const distribution = [
// //         { name: "Basic", value: 40 },
// //         { name: "Premium", value: 35 },
// //         { name: "Gold", value: 25 },
// //       ];
// //       setMembershipDistribution(distribution);
// //     } catch (error) {
// //       console.error("Error fetching dashboard data:", error);
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   const StatCard = ({ title, value, icon: Icon, color, growth, subtitle }) => (
// //     <Card className="stat-card">
// //       <Card.Body>
// //         <div className="d-flex justify-content-between align-items-start">
// //           <div>
// //             <h6 className="card-title text-muted mb-1">{title}</h6>
// //             <h2 className="mb-0">{value}</h2>
// //             {subtitle && <small className="text-muted">{subtitle}</small>}
// //           </div>
// //           <div className={`stat-icon bg-${color}`}>
// //             <Icon size={24} />
// //           </div>
// //         </div>
// //         {growth !== undefined && (
// //           <div className="d-flex align-items-center mt-2">
// //             {growth >= 0 ? (
// //               <FaArrowUp className="text-success me-1" />
// //             ) : (
// //               <FaArrowDown className="text-danger me-1" />
// //             )}
// //             <span className={growth >= 0 ? "text-success" : "text-danger"}>
// //               {Math.abs(growth)}%
// //             </span>
// //             <span className="text-muted ms-2">from last month</span>
// //           </div>
// //         )}
// //       </Card.Body>
// //     </Card>
// //   );

// //   if (loading) {
// //     return (
// //       <Container fluid>
// //         <div className="text-center py-5">
// //           <div className="spinner-border text-primary" role="status">
// //             <span className="visually-hidden">Loading...</span>
// //           </div>
// //         </div>
// //       </Container>
// //     );
// //   }

// //   return (
// //     <Container fluid className="dashboard-container">
// //       {/* Page Header */}
// //       <div className="page-header mb-4">
// //         <div className="d-flex justify-content-between align-items-center">
// //           <div>
// //             <h1 className="page-title">Dashboard</h1>
// //             <p className="page-subtitle">
// //               Welcome back! Here's what's happening with your gym.
// //             </p>
// //           </div>
// //           <div>
// //             <Button variant="primary" className="me-2">
// //               <FaBell className="me-2" /> Notifications
// //             </Button>
// //             <Button variant="success">
// //               <FaUserPlus className="me-2" /> Quick Add
// //             </Button>
// //           </div>
// //         </div>
// //       </div>

// //       {/* Stats Cards */}
// //       <Row className="mb-4">
// //         <Col xl={3} lg={6} md={6} sm={12} className="mb-3">
// //           <StatCard
// //             title="Total Members"
// //             value={stats.totalMembers}
// //             icon={FaUsers}
// //             color="primary"
// //             growth={stats.memberGrowth}
// //           />
// //         </Col>
// //         <Col xl={3} lg={6} md={6} sm={12} className="mb-3">
// //           <StatCard
// //             title="Active Members"
// //             value={stats.activeMembers}
// //             icon={FaCalendarCheck}
// //             color="success"
// //             subtitle={`${(
// //               (stats.activeMembers / stats.totalMembers) *
// //               100
// //             ).toFixed(1)}% active`}
// //           />
// //         </Col>
// //         <Col xl={3} lg={6} md={6} sm={12} className="mb-3">
// //           <StatCard
// //             title="Monthly Revenue"
// //             value={`₹${stats.monthlyRevenue.toLocaleString()}`}
// //             icon={FaDollarSign}
// //             color="warning"
// //             growth={stats.revenueGrowth}
// //           />
// //         </Col>
// //         <Col xl={3} lg={6} md={6} sm={12} className="mb-3">
// //           <StatCard
// //             title="Pending Payments"
// //             value={stats.pendingPayments}
// //             icon={FaChartLine}
// //             color="danger"
// //           />
// //         </Col>
// //       </Row>

// //       {/* Charts Section */}
// //       <Row className="mb-4">
// //         <Col lg={8} md={12} className="mb-4">
// //           <Card>
// //             <Card.Header>
// //               <h5 className="mb-0">Revenue Overview</h5>
// //             </Card.Header>
// //             <Card.Body>
// //               <div style={{ height: "300px" }}>
// //                 <ResponsiveContainer width="100%" height="100%">
// //                   <LineChart data={chartData}>
// //                     <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
// //                     <XAxis dataKey="month" stroke="#666" />
// //                     <YAxis stroke="#666" />
// //                     <Tooltip
// //                       formatter={(value) => [`₹${value}`, "Revenue"]}
// //                       labelFormatter={(label) => `Month: ${label}`}
// //                     />
// //                     <Legend />
// //                     <Line
// //                       type="monotone"
// //                       dataKey="revenue"
// //                       stroke="#8884d8"
// //                       strokeWidth={2}
// //                       dot={{ r: 4 }}
// //                       activeDot={{ r: 6 }}
// //                       name="Revenue"
// //                     />
// //                   </LineChart>
// //                 </ResponsiveContainer>
// //               </div>
// //             </Card.Body>
// //           </Card>
// //         </Col>

// //         <Col lg={4} md={12} className="mb-4">
// //           <Card>
// //             <Card.Header>
// //               <h5 className="mb-0">Membership Distribution</h5>
// //             </Card.Header>
// //             <Card.Body>
// //               <div style={{ height: "300px" }}>
// //                 <ResponsiveContainer width="100%" height="100%">
// //                   <PieChart>
// //                     <Pie
// //                       data={membershipDistribution}
// //                       cx="50%"
// //                       cy="50%"
// //                       labelLine={false}
// //                       label={({ name, percent }) =>
// //                         `${name}: ${(percent * 100).toFixed(0)}%`
// //                       }
// //                       outerRadius={80}
// //                       fill="#8884d8"
// //                       dataKey="value"
// //                     >
// //                       {membershipDistribution.map((entry, index) => (
// //                         <Cell
// //                           key={`cell-${index}`}
// //                           fill={COLORS[index % COLORS.length]}
// //                         />
// //                       ))}
// //                     </Pie>
// //                     <Tooltip
// //                       formatter={(value) => [`${value} members`, "Count"]}
// //                     />
// //                   </PieChart>
// //                 </ResponsiveContainer>
// //               </div>
// //             </Card.Body>
// //           </Card>
// //         </Col>
// //       </Row>

// //       {/* Recent Activity */}
// //       <Row>
// //         <Col lg={6} md={12} className="mb-4">
// //           <Card>
// //             <Card.Header className="d-flex justify-content-between align-items-center">
// //               <h5 className="mb-0">Recent Members</h5>
// //               <Button variant="link" size="sm">
// //                 View All
// //               </Button>
// //             </Card.Header>
// //             <Card.Body>
// //               <div className="table-responsive">
// //                 <Table hover className="mb-0">
// //                   <thead>
// //                     <tr>
// //                       <th>Name</th>
// //                       <th>Join Date</th>
// //                       <th>Plan</th>
// //                       <th>Status</th>
// //                     </tr>
// //                   </thead>
// //                   <tbody>
// //                     {recentMembers.map((member) => (
// //                       <tr key={member.id}>
// //                         <td>
// //                           <div className="d-flex align-items-center">
// //                             <div className="avatar-sm bg-primary text-white rounded-circle d-flex align-items-center justify-content-center me-2">
// //                               {member.first_name?.[0] || "M"}
// //                             </div>
// //                             <div>
// //                               <div className="fw-medium">
// //                                 {member.first_name} {member.last_name}
// //                               </div>
// //                               <small className="text-muted">
// //                                 {member.member_id}
// //                               </small>
// //                             </div>
// //                           </div>
// //                         </td>
// //                         <td>
// //                           {new Date(member.created_at).toLocaleDateString()}
// //                         </td>
// //                         <td>
// //                           <span className="badge bg-info">Basic</span>
// //                         </td>
// //                         <td>
// //                           <span
// //                             className={`badge ${
// //                               member.is_active ? "bg-success" : "bg-secondary"
// //                             }`}
// //                           >
// //                             {member.is_active ? "Active" : "Inactive"}
// //                           </span>
// //                         </td>
// //                       </tr>
// //                     ))}
// //                   </tbody>
// //                 </Table>
// //               </div>
// //             </Card.Body>
// //           </Card>
// //         </Col>

// //         <Col lg={6} md={12} className="mb-4">
// //           <Card>
// //             <Card.Header className="d-flex justify-content-between align-items-center">
// //               <h5 className="mb-0">Recent Payments</h5>
// //               <Button variant="link" size="sm">
// //                 View All
// //               </Button>
// //             </Card.Header>
// //             <Card.Body>
// //               <div className="table-responsive">
// //                 <Table hover className="mb-0">
// //                   <thead>
// //                     <tr>
// //                       <th>Member</th>
// //                       <th>Amount</th>
// //                       <th>Date</th>
// //                       <th>Mode</th>
// //                       <th>Status</th>
// //                     </tr>
// //                   </thead>
// //                   <tbody>
// //                     {recentPayments.map((payment) => (
// //                       <tr key={payment.id}>
// //                         <td>Member #{payment.plan?.member || "N/A"}</td>
// //                         <td className="fw-bold">₹{payment.paid_amount}</td>
// //                         <td>
// //                           {new Date(payment.payment_date).toLocaleDateString()}
// //                         </td>
// //                         <td>
// //                           <span className="badge bg-secondary">
// //                             {payment.payment_mode}
// //                           </span>
// //                         </td>
// //                         <td>
// //                           <span className="badge bg-success">Completed</span>
// //                         </td>
// //                       </tr>
// //                     ))}
// //                   </tbody>
// //                 </Table>
// //               </div>
// //             </Card.Body>
// //           </Card>
// //         </Col>
// //       </Row>

// //       {/* Quick Stats */}
// //       <Row>
// //         <Col md={12}>
// //           <Card>
// //             <Card.Header>
// //               <h5 className="mb-0">Activity Summary</h5>
// //             </Card.Header>
// //             <Card.Body>
// //               <Row>
// //                 <Col md={4}>
// //                   <div className="mb-3">
// //                     <div className="d-flex justify-content-between mb-1">
// //                       <span className="text-muted">New Members Target</span>
// //                       <span className="fw-bold">75%</span>
// //                     </div>
// //                     <ProgressBar now={75} variant="success" />
// //                   </div>
// //                 </Col>
// //                 <Col md={4}>
// //                   <div className="mb-3">
// //                     <div className="d-flex justify-content-between mb-1">
// //                       <span className="text-muted">Revenue Target</span>
// //                       <span className="fw-bold">90%</span>
// //                     </div>
// //                     <ProgressBar now={90} variant="primary" />
// //                   </div>
// //                 </Col>
// //                 <Col md={4}>
// //                   <div className="mb-3">
// //                     <div className="d-flex justify-content-between mb-1">
// //                       <span className="text-muted">Renewal Rate</span>
// //                       <span className="fw-bold">85%</span>
// //                     </div>
// //                     <ProgressBar now={85} variant="warning" />
// //                   </div>
// //                 </Col>
// //               </Row>
// //             </Card.Body>
// //           </Card>
// //         </Col>
// //       </Row>
// //     </Container>
// //   );
// // };

// // export default Dashboard;
// import React, { useState, useEffect } from "react";
// import {
//   Card,
//   Row,
//   Col,
//   Container,
//   Table,
//   ProgressBar,
//   Button,
//   Spinner,
//   Alert,
// } from "react-bootstrap";
// import {
//   FaUsers,
//   FaDollarSign,
//   FaCalendarCheck,
//   FaChartLine,
//   FaUserPlus,
//   FaBell,
//   FaArrowUp,
//   FaArrowDown,
//   FaMoneyBillWave,
//   FaCalendar,
//   FaClock,
// } from "react-icons/fa";
// import {
//   LineChart,
//   Line,
//   BarChart,
//   Bar,
//   PieChart,
//   Pie,
//   Cell,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   Legend,
//   ResponsiveContainer,
// } from "recharts";
// import { Badge } from "react-bootstrap";

// import { gymMembersAPI } from "../../api/gymMembers";
// import { membershipAPI } from "../../api/membershipPlans";
// import Swal from "sweetalert2";
// import "./Dashboard.css";

// const Dashboard = () => {
//   const [stats, setStats] = useState({
//     totalMembers: 0,
//     activeMembers: 0,
//     totalRevenue: 0,
//     pendingPayments: 0,
//     newMembersThisMonth: 0,
//     activePlans: 0,
//   });

//   const [recentMembers, setRecentMembers] = useState([]);
//   const [recentPlans, setRecentPlans] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const [revenueChartData, setRevenueChartData] = useState([]);
//   const [membershipTypeData, setMembershipTypeData] = useState([]);

//   const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042", "#8884D8"];

//   useEffect(() => {
//     fetchDashboardData();
//   }, []);

//   const fetchDashboardData = async () => {
//     setLoading(true);
//     setError("");
//     try {
//       // Fetch all data in parallel
//       const [membersResponse, plansResponse] = await Promise.all([
//         gymMembersAPI.getMembers(),
//         membershipAPI.getPlans(),
//       ]);

//       const members = membersResponse.data?.data || membersResponse.data || [];
//       const plans = plansResponse.data?.data || plansResponse.data || [];

//       // Calculate stats
//       const totalMembers = members.length;
//       const activeMembers = members.filter((m) => m.is_active).length;

//       // Calculate total revenue (sum of all plan amounts)
//       const totalRevenue = plans.reduce((sum, plan) => {
//         return sum + parseFloat(plan.total_amount || plan.amount || 0);
//       }, 0);

//       // Calculate total paid amount
//       const totalPaid = plans.reduce((sum, plan) => {
//         return sum + parseFloat(plan.paid_amount || 0);
//       }, 0);

//       // Calculate pending payments
//       const pendingPayments = plans.reduce((sum, plan) => {
//         return sum + parseFloat(plan.pending_amount || 0);
//       }, 0);

//       // Get current month new members
//       const currentMonth = new Date().getMonth();
//       const currentYear = new Date().getFullYear();
//       const newMembersThisMonth = members.filter((member) => {
//         if (!member.created_at) return false;
//         const joinDate = new Date(member.created_at);
//         return (
//           joinDate.getMonth() === currentMonth &&
//           joinDate.getFullYear() === currentYear
//         );
//       }).length;

//       // Count active plans
//       const activePlans = plans.filter((plan) => plan.is_active).length;

//       setStats({
//         totalMembers,
//         activeMembers,
//         totalRevenue,
//         totalPaid,
//         pendingPayments,
//         newMembersThisMonth,
//         activePlans,
//       });

//       // Set recent members (last 5)
//       const sortedMembers = [...members]
//         .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
//         .slice(0, 5);
//       setRecentMembers(sortedMembers);

//       // Set recent plans (last 5)
//       const sortedPlans = [...plans]
//         .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
//         .slice(0, 5);
//       setRecentPlans(sortedPlans);

//       // Prepare revenue chart data for last 6 months
//       const monthlyData = prepareMonthlyRevenueData(plans);
//       setRevenueChartData(monthlyData);

//       // Prepare membership type distribution
//       const typeDistribution = prepareMembershipTypeDistribution(plans);
//       setMembershipTypeData(typeDistribution);
//     } catch (error) {
//       console.error("Error fetching dashboard data:", error);
//       setError("Failed to load dashboard data. Please try again.");
//       Swal.fire({
//         icon: "error",
//         title: "Error",
//         text: "Failed to load dashboard data",
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   const prepareMonthlyRevenueData = (plans) => {
//     const months = [];
//     const now = new Date();

//     // Get last 6 months
//     for (let i = 5; i >= 0; i--) {
//       const date = new Date();
//       date.setMonth(now.getMonth() - i);
//       months.push({
//         month: date.toLocaleString("default", { month: "short" }),
//         revenue: 0,
//         paid: 0,
//       });
//     }

//     // Calculate revenue and paid amounts per month
//     plans.forEach((plan) => {
//       const createdDate = new Date(plan.created_at);
//       const monthYear = createdDate.toLocaleString("default", {
//         month: "short",
//       });

//       const monthData = months.find((m) => m.month === monthYear);
//       if (monthData) {
//         monthData.revenue += parseFloat(plan.total_amount || plan.amount || 0);
//         monthData.paid += parseFloat(plan.paid_amount || 0);
//       }
//     });

//     return months;
//   };

//   const prepareMembershipTypeDistribution = (plans) => {
//     const distribution = {};

//     plans.forEach((plan) => {
//       const typeId = plan.subscription_type;
//       if (!distribution[typeId]) {
//         distribution[typeId] = {
//           name: `Type ${typeId}`,
//           value: 0,
//         };
//       }
//       distribution[typeId].value++;
//     });

//     // Convert to array and sort by value
//     return Object.values(distribution)
//       .sort((a, b) => b.value - a.value)
//       .slice(0, 5); // Top 5 types
//   };

//   const StatCard = ({
//     title,
//     value,
//     icon: Icon,
//     color,
//     growth,
//     subtitle,
//     prefix = "",
//   }) => (
//     <Card className="stat-card">
//       <Card.Body>
//         <div className="d-flex justify-content-between align-items-start">
//           <div>
//             <h6 className="card-title text-muted mb-1">{title}</h6>
//             <h2 className="mb-0">
//               {prefix}
//               {value}
//             </h2>
//             {subtitle && <small className="text-muted">{subtitle}</small>}
//           </div>
//           <div className={`stat-icon bg-${color}`}>
//             <Icon size={24} />
//           </div>
//         </div>
//         {growth !== undefined && (
//           <div className="d-flex align-items-center mt-2">
//             {growth >= 0 ? (
//               <FaArrowUp className="text-success me-1" />
//             ) : (
//               <FaArrowDown className="text-danger me-1" />
//             )}
//             <span className={growth >= 0 ? "text-success" : "text-danger"}>
//               {Math.abs(growth)}%
//             </span>
//             <span className="text-muted ms-2">from last month</span>
//           </div>
//         )}
//       </Card.Body>
//     </Card>
//   );

//   const formatCurrency = (amount) => {
//     return `₹${parseFloat(amount || 0).toLocaleString("en-IN", {
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2,
//     })}`;
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return "N/A";
//     try {
//       return new Date(dateString).toLocaleDateString();
//     } catch (error) {
//       return "Invalid Date";
//     }
//   };

//   if (loading) {
//     return (
//       <Container fluid className="dashboard-container">
//         <div className="text-center py-5">
//           <Spinner animation="border" variant="primary" />
//           <p className="mt-2">Loading dashboard data...</p>
//         </div>
//       </Container>
//     );
//   }

//   return (
//     <Container fluid className="dashboard-container">
//       {/* Page Header */}
//       <div className="page-header mb-4">
//         <div className="d-flex justify-content-between align-items-center">
//           <div>
//             <h1 className="page-title">Dashboard</h1>
//             <p className="page-subtitle">
//               Welcome back! Here's what's happening with your gym.
//             </p>
//           </div>
//           <div>
//             <Button
//               variant="outline-secondary"
//               className="me-2"
//               onClick={fetchDashboardData}
//             >
//               Refresh
//             </Button>
//             <Button
//               variant="success"
//               onClick={() => (window.location.href = "/members/add")}
//             >
//               <FaUserPlus className="me-2" /> Add Member
//             </Button>
//           </div>
//         </div>
//       </div>

//       {error && (
//         <Alert variant="danger" onClose={() => setError("")} dismissible>
//           {error}
//         </Alert>
//       )}

//       {/* Stats Cards */}
//       <Row className="mb-4">
//         <Col xl={3} lg={6} md={6} sm={12} className="mb-3">
//           <StatCard
//             title="Total Members"
//             value={stats.totalMembers}
//             icon={FaUsers}
//             color="primary"
//             subtitle={`${stats.newMembersThisMonth} new this month`}
//           />
//         </Col>
//         <Col xl={3} lg={6} md={6} sm={12} className="mb-3">
//           <StatCard
//             title="Active Members"
//             value={stats.activeMembers}
//             icon={FaCalendarCheck}
//             color="success"
//             subtitle={`${(
//               (stats.activeMembers / stats.totalMembers) *
//               100
//             ).toFixed(1)}% active`}
//           />
//         </Col>
//         <Col xl={3} lg={6} md={6} sm={12} className="mb-3">
//           <StatCard
//             title="Total Revenue"
//             value={formatCurrency(stats.totalRevenue)}
//             icon={FaDollarSign}
//             color="warning"
//             subtitle={`${formatCurrency(stats.pendingPayments)} pending`}
//           />
//         </Col>
//         <Col xl={3} lg={6} md={6} sm={12} className="mb-3">
//           <StatCard
//             title="Active Plans"
//             value={stats.activePlans}
//             icon={FaChartLine}
//             color="info"
//             subtitle={`${formatCurrency(stats.totalPaid)} collected`}
//           />
//         </Col>
//       </Row>

//       {/* Charts Section */}
//       <Row className="mb-4">
//         <Col lg={8} md={12} className="mb-4">
//           <Card>
//             <Card.Header>
//               <h5 className="mb-0">Revenue Overview (Last 6 Months)</h5>
//             </Card.Header>
//             <Card.Body>
//               <div style={{ height: "300px" }}>
//                 <ResponsiveContainer width="100%" height="100%">
//                   <BarChart data={revenueChartData}>
//                     <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
//                     <XAxis dataKey="month" stroke="#666" />
//                     <YAxis stroke="#666" />
//                     <Tooltip
//                       formatter={(value) => [formatCurrency(value), "Amount"]}
//                       labelFormatter={(label) => `Month: ${label}`}
//                     />
//                     <Legend />
//                     <Bar
//                       dataKey="revenue"
//                       name="Total Revenue"
//                       fill="#8884d8"
//                       radius={[4, 4, 0, 0]}
//                     />
//                     <Bar
//                       dataKey="paid"
//                       name="Amount Collected"
//                       fill="#82ca9d"
//                       radius={[4, 4, 0, 0]}
//                     />
//                   </BarChart>
//                 </ResponsiveContainer>
//               </div>
//             </Card.Body>
//           </Card>
//         </Col>

//         <Col lg={4} md={12} className="mb-4">
//           <Card>
//             <Card.Header>
//               <h5 className="mb-0">Membership Type Distribution</h5>
//             </Card.Header>
//             <Card.Body>
//               <div style={{ height: "300px" }}>
//                 <ResponsiveContainer width="100%" height="100%">
//                   <PieChart>
//                     <Pie
//                       data={membershipTypeData}
//                       cx="50%"
//                       cy="50%"
//                       labelLine={false}
//                       label={({ name, percent }) =>
//                         `${name}: ${(percent * 100).toFixed(0)}%`
//                       }
//                       outerRadius={80}
//                       fill="#8884d8"
//                       dataKey="value"
//                     >
//                       {membershipTypeData.map((entry, index) => (
//                         <Cell
//                           key={`cell-${index}`}
//                           fill={COLORS[index % COLORS.length]}
//                         />
//                       ))}
//                     </Pie>
//                     <Tooltip
//                       formatter={(value) => [`${value} plans`, "Count"]}
//                     />
//                   </PieChart>
//                 </ResponsiveContainer>
//               </div>
//             </Card.Body>
//           </Card>
//         </Col>
//       </Row>

//       {/* Recent Activity */}
//       <Row>
//         <Col lg={6} md={12} className="mb-4">
//           <Card>
//             <Card.Header className="d-flex justify-content-between align-items-center">
//               <h5 className="mb-0">Recent Members</h5>
//               <Button
//                 variant="link"
//                 size="sm"
//                 onClick={() => (window.location.href = "/members")}
//               >
//                 View All
//               </Button>
//             </Card.Header>
//             <Card.Body>
//               <div className="table-responsive">
//                 <Table hover className="mb-0">
//                   <thead>
//                     <tr>
//                       <th>Name</th>
//                       <th>Member ID</th>
//                       <th>Join Date</th>
//                       <th>Status</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {recentMembers.length === 0 ? (
//                       <tr>
//                         <td colSpan="4" className="text-center py-4">
//                           <div className="text-muted">
//                             <FaUsers size={32} className="mb-2" />
//                             <p>No members found</p>
//                           </div>
//                         </td>
//                       </tr>
//                     ) : (
//                       recentMembers.map((member) => (
//                         <tr key={member.id}>
//                           <td>
//                             <div className="d-flex align-items-center">
//                               <div className="avatar-sm bg-primary text-white rounded-circle d-flex align-items-center justify-content-center me-2">
//                                 {member.first_name?.[0]?.toUpperCase() || "M"}
//                               </div>
//                               <div>
//                                 <div className="fw-medium">
//                                   {member.first_name} {member.last_name}
//                                 </div>
//                                 <small className="text-muted">
//                                   {member.email}
//                                 </small>
//                               </div>
//                             </div>
//                           </td>
//                           {/* <td>
//                             <Badge bg="secondary">{member.member_id}</Badge>
//                           </td> */}
//                           <td>
//                             <Badge bg="secondary">{member.member_id}</Badge>
//                           </td>
//                           <td>
//                             <FaCalendar className="me-1 text-muted" />
//                             {formatDate(member.created_at)}
//                           </td>
//                           <td>
//                             <span
//                               className={`badge ${
//                                 member.is_active ? "bg-success" : "bg-secondary"
//                               }`}
//                             >
//                               {member.is_active ? "Active" : "Inactive"}
//                             </span>
//                           </td>
//                         </tr>
//                       ))
//                     )}
//                   </tbody>
//                 </Table>
//               </div>
//             </Card.Body>
//           </Card>
//         </Col>

//         <Col lg={6} md={12} className="mb-4">
//           <Card>
//             <Card.Header className="d-flex justify-content-between align-items-center">
//               <h5 className="mb-0">Recent Membership Plans</h5>
//               <Button
//                 variant="link"
//                 size="sm"
//                 onClick={() => (window.location.href = "/membership/plans")}
//               >
//                 View All
//               </Button>
//             </Card.Header>
//             <Card.Body>
//               <div className="table-responsive">
//                 <Table hover className="mb-0">
//                   <thead>
//                     <tr>
//                       <th>Plan ID</th>
//                       <th>Member</th>
//                       <th>Amount</th>
//                       <th>Status</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {recentPlans.length === 0 ? (
//                       <tr>
//                         <td colSpan="4" className="text-center py-4">
//                           <div className="text-muted">
//                             <FaMoneyBillWave size={32} className="mb-2" />
//                             <p>No plans found</p>
//                           </div>
//                         </td>
//                       </tr>
//                     ) : (
//                       recentPlans.map((plan) => (
//                         <tr key={plan.id}>
//                           <td>
//                             <div className="fw-bold">#{plan.id}</div>
//                           </td>
//                           <td>
//                             <div>Member #{plan.member}</div>
//                             <small className="text-muted">
//                               Type: {plan.subscription_type}
//                             </small>
//                           </td>
//                           <td>
//                             <div className="fw-bold">
//                               {formatCurrency(plan.total_amount || plan.amount)}
//                             </div>
//                             <div className="d-flex">
//                               <small className="text-success me-2">
//                                 Paid: {formatCurrency(plan.paid_amount)}
//                               </small>
//                               <small className="text-danger">
//                                 Pending: {formatCurrency(plan.pending_amount)}
//                               </small>
//                             </div>
//                           </td>
//                           <td>
//                             <div>
//                               <span
//                                 className={`badge ${
//                                   plan.is_active ? "bg-success" : "bg-secondary"
//                                 }`}
//                               >
//                                 {plan.is_active ? "Active" : "Inactive"}
//                               </span>
//                               <div className="mt-1">
//                                 <small className="text-muted">
//                                   <FaClock className="me-1" />
//                                   {formatDate(plan.expiry_date)}
//                                 </small>
//                               </div>
//                             </div>
//                           </td>
//                         </tr>
//                       ))
//                     )}
//                   </tbody>
//                 </Table>
//               </div>
//             </Card.Body>
//           </Card>
//         </Col>
//       </Row>

//       {/* Quick Stats */}
//       <Row>
//         <Col md={12}>
//           <Card>
//             <Card.Header>
//               <h5 className="mb-0">Performance Summary</h5>
//             </Card.Header>
//             <Card.Body>
//               <Row>
//                 <Col md={3}>
//                   <div className="mb-3">
//                     <div className="d-flex justify-content-between mb-1">
//                       <span className="text-muted">
//                         <FaUsers className="me-1" /> Member Growth
//                       </span>
//                       <span className="fw-bold">
//                         {stats.newMembersThisMonth} new
//                       </span>
//                     </div>
//                     <ProgressBar
//                       now={Math.min(
//                         (stats.newMembersThisMonth / 50) * 100,
//                         100
//                       )}
//                       variant="success"
//                     />
//                   </div>
//                 </Col>
//                 <Col md={3}>
//                   <div className="mb-3">
//                     <div className="d-flex justify-content-between mb-1">
//                       <span className="text-muted">
//                         <FaDollarSign className="me-1" /> Collection Rate
//                       </span>
//                       <span className="fw-bold">
//                         {stats.totalRevenue > 0
//                           ? (
//                               (stats.totalPaid / stats.totalRevenue) *
//                               100
//                             ).toFixed(1)
//                           : 0}
//                         %
//                       </span>
//                     </div>
//                     <ProgressBar
//                       now={
//                         stats.totalRevenue > 0
//                           ? (stats.totalPaid / stats.totalRevenue) * 100
//                           : 0
//                       }
//                       variant="primary"
//                     />
//                   </div>
//                 </Col>
//                 <Col md={3}>
//                   <div className="mb-3">
//                     <div className="d-flex justify-content-between mb-1">
//                       <span className="text-muted">
//                         <FaChartLine className="me-1" /> Active Rate
//                       </span>
//                       <span className="fw-bold">
//                         {stats.totalMembers > 0
//                           ? (
//                               (stats.activeMembers / stats.totalMembers) *
//                               100
//                             ).toFixed(1)
//                           : 0}
//                         %
//                       </span>
//                     </div>
//                     <ProgressBar
//                       now={
//                         stats.totalMembers > 0
//                           ? (stats.activeMembers / stats.totalMembers) * 100
//                           : 0
//                       }
//                       variant="warning"
//                     />
//                   </div>
//                 </Col>
//                 <Col md={3}>
//                   <div className="mb-3">
//                     <div className="d-flex justify-content-between mb-1">
//                       <span className="text-muted">
//                         <FaCalendarCheck className="me-1" /> Plan Utilization
//                       </span>
//                       <span className="fw-bold">
//                         {stats.totalMembers > 0
//                           ? (
//                               (stats.activePlans / stats.totalMembers) *
//                               100
//                             ).toFixed(1)
//                           : 0}
//                         %
//                       </span>
//                     </div>
//                     <ProgressBar
//                       now={
//                         stats.totalMembers > 0
//                           ? (stats.activePlans / stats.totalMembers) * 100
//                           : 0
//                       }
//                       variant="info"
//                     />
//                   </div>
//                 </Col>
//               </Row>
//             </Card.Body>
//           </Card>
//         </Col>
//       </Row>
//     </Container>
//   );
// };

// export default Dashboard;

import React, { useState, useEffect } from "react";
import {
  Card,
  Row,
  Col,
  Container,
  Table,
  ProgressBar,
  Button,
  Spinner,
  Alert,
  Badge,
} from "react-bootstrap";
import {
  FaUsers,
  FaDollarSign,
  FaCalendarCheck,
  FaChartLine,
  FaUserPlus,
  FaBell,
  FaArrowUp,
  FaArrowDown,
  FaMoneyBillWave,
  FaCalendar,
  FaClock,
  FaExclamationTriangle,
  FaCalendarTimes,
} from "react-icons/fa";
import {
  LineChart,
  Line,
  BarChart,
  Bar,
  PieChart,
  Pie,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { gymMembersAPI } from "../../api/gymMembers";
import { membershipAPI } from "../../api/membershipPlans";
import Swal from "sweetalert2";
import "./Dashboard.css";

const Dashboard = () => {
  const [stats, setStats] = useState({
    totalMembers: 0,
    activeMembers: 0,
    totalRevenue: 0,
    pendingPayments: 0,
    newMembersThisMonth: 0,
    activePlans: 0,
  });

  const [recentMembers, setRecentMembers] = useState([]);
  const [recentPlans, setRecentPlans] = useState([]);
  const [expiringThisMonth, setExpiringThisMonth] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [revenueChartData, setRevenueChartData] = useState([]);
  const [membershipTypeData, setMembershipTypeData] = useState([]);

  const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042", "#8884D8"];

  useEffect(() => {
    fetchDashboardData();
  }, []);

  const fetchDashboardData = async () => {
    setLoading(true);
    setError("");
    try {
      // Fetch all data in parallel
      const [membersResponse, plansResponse] = await Promise.all([
        gymMembersAPI.getMembers(),
        membershipAPI.getPlans(),
      ]);

      const members = membersResponse.data?.data || membersResponse.data || [];
      const plans = plansResponse.data?.data || plansResponse.data || [];

      // Calculate stats
      const totalMembers = members.length;
      const activeMembers = members.filter((m) => m.is_active).length;

      // Calculate total revenue (sum of all plan amounts)
      const totalRevenue = plans.reduce((sum, plan) => {
        return sum + parseFloat(plan.total_amount || plan.amount || 0);
      }, 0);

      // Calculate total paid amount
      const totalPaid = plans.reduce((sum, plan) => {
        return sum + parseFloat(plan.paid_amount || 0);
      }, 0);

      // Calculate pending payments
      const pendingPayments = plans.reduce((sum, plan) => {
        return sum + parseFloat(plan.pending_amount || 0);
      }, 0);

      // Get current month new members
      const currentMonth = new Date().getMonth();
      const currentYear = new Date().getFullYear();
      const newMembersThisMonth = members.filter((member) => {
        if (!member.created_at) return false;
        const joinDate = new Date(member.created_at);
        return (
          joinDate.getMonth() === currentMonth &&
          joinDate.getFullYear() === currentYear
        );
      }).length;

      // Count active plans
      const activePlans = plans.filter((plan) => plan.is_active).length;

      setStats({
        totalMembers,
        activeMembers,
        totalRevenue,
        totalPaid,
        pendingPayments,
        newMembersThisMonth,
        activePlans,
      });

      // Set recent members (last 5)
      const sortedMembers = [...members]
        .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
        .slice(0, 5);
      setRecentMembers(sortedMembers);

      // Set recent plans (last 5)
      const sortedPlans = [...plans]
        .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
        .slice(0, 5);
      setRecentPlans(sortedPlans);

      // Prepare expiring this month data
      const expiringPlans = prepareExpiringThisMonth(members);
      setExpiringThisMonth(expiringPlans);

      // Prepare revenue chart data for last 6 months
      const monthlyData = prepareMonthlyRevenueData(plans);
      setRevenueChartData(monthlyData);

      // Prepare membership type distribution
      const typeDistribution = prepareMembershipTypeDistribution(plans);
      setMembershipTypeData(typeDistribution);
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
      setError("Failed to load dashboard data. Please try again.");
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to load dashboard data",
      });
    } finally {
      setLoading(false);
    }
  };

  const prepareExpiringThisMonth = (members) => {
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth();
    const currentYear = currentDate.getFullYear();

    const expiringPlans = [];

    members.forEach((member) => {
      const plans = [];

      // Check current plan
      if (member.current_plan && member.current_plan.expiry_date) {
        const expiryDate = new Date(member.current_plan.expiry_date);
        if (
          expiryDate.getMonth() === currentMonth &&
          expiryDate.getFullYear() === currentYear
        ) {
          plans.push({
            ...member.current_plan,
            source: "current",
            memberInfo: member,
          });
        }
      }

      // Check previous plan
      if (member.previous_plan && member.previous_plan.expiry_date) {
        const expiryDate = new Date(member.previous_plan.expiry_date);
        if (
          expiryDate.getMonth() === currentMonth &&
          expiryDate.getFullYear() === currentYear
        ) {
          plans.push({
            ...member.previous_plan,
            source: "previous",
            memberInfo: member,
          });
        }
      }

      // Add all expiring plans to the list
      plans.forEach((plan) => {
        expiringPlans.push({
          ...plan,
          memberName: `${member.first_name} ${member.last_name}`,
          memberId: member.member_id,
          phone: member.mobile_number,
          email: member.email,
          daysLeft: Math.ceil(
            (new Date(plan.expiry_date) - currentDate) / (1000 * 60 * 60 * 24)
          ),
        });
      });
    });

    // Sort by days left (ascending)
    return expiringPlans.sort((a, b) => a.daysLeft - b.daysLeft);
  };

  const prepareMonthlyRevenueData = (plans) => {
    const months = [];
    const now = new Date();

    // Get last 6 months
    for (let i = 5; i >= 0; i--) {
      const date = new Date();
      date.setMonth(now.getMonth() - i);
      months.push({
        month: date.toLocaleString("default", { month: "short" }),
        revenue: 0,
        paid: 0,
      });
    }

    // Calculate revenue and paid amounts per month
    plans.forEach((plan) => {
      const createdDate = new Date(plan.created_at);
      const monthYear = createdDate.toLocaleString("default", {
        month: "short",
      });

      const monthData = months.find((m) => m.month === monthYear);
      if (monthData) {
        monthData.revenue += parseFloat(plan.total_amount || plan.amount || 0);
        monthData.paid += parseFloat(plan.paid_amount || 0);
      }
    });

    return months;
  };

  const prepareMembershipTypeDistribution = (plans) => {
    const distribution = {};

    plans.forEach((plan) => {
      const typeId = plan.subscription_type;
      if (!distribution[typeId]) {
        distribution[typeId] = {
          name: `Type ${typeId}`,
          value: 0,
        };
      }
      distribution[typeId].value++;
    });

    // Convert to array and sort by value
    return Object.values(distribution)
      .sort((a, b) => b.value - a.value)
      .slice(0, 5); // Top 5 types
  };

  const StatCard = ({
    title,
    value,
    icon: Icon,
    color,
    growth,
    subtitle,
    prefix = "",
  }) => (
    <Card className="stat-card">
      <Card.Body>
        <div className="d-flex justify-content-between align-items-start">
          <div>
            <h6 className="card-title text-muted mb-1">{title}</h6>
            <h2 className="mb-0">
              {prefix}
              {value}
            </h2>
            {subtitle && <small className="text-muted">{subtitle}</small>}
          </div>
          <div className={`stat-icon bg-${color}`}>
            <Icon size={24} />
          </div>
        </div>
        {growth !== undefined && (
          <div className="d-flex align-items-center mt-2">
            {growth >= 0 ? (
              <FaArrowUp className="text-success me-1" />
            ) : (
              <FaArrowDown className="text-danger me-1" />
            )}
            <span className={growth >= 0 ? "text-success" : "text-danger"}>
              {Math.abs(growth)}%
            </span>
            <span className="text-muted ms-2">from last month</span>
          </div>
        )}
      </Card.Body>
    </Card>
  );

  const formatCurrency = (amount) => {
    return `₹${parseFloat(amount || 0).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    try {
      return new Date(dateString).toLocaleDateString();
    } catch (error) {
      return "Invalid Date";
    }
  };

  const getDaysLeftBadge = (daysLeft) => {
    if (daysLeft < 0) {
      return <Badge bg="danger">Expired</Badge>;
    } else if (daysLeft <= 7) {
      return <Badge bg="warning">{daysLeft} days left</Badge>;
    } else if (daysLeft <= 30) {
      return <Badge bg="info">{daysLeft} days left</Badge>;
    } else {
      return <Badge bg="success">{daysLeft} days left</Badge>;
    }
  };

  const getPlanSourceBadge = (source) => {
    if (source === "current") {
      return <Badge bg="success">Current</Badge>;
    } else {
      return <Badge bg="secondary">Previous</Badge>;
    }
  };

  if (loading) {
    return (
      <Container fluid className="dashboard-container">
        <div className="text-center py-5">
          <Spinner animation="border" variant="primary" />
          <p className="mt-2">Loading dashboard data...</p>
        </div>
      </Container>
    );
  }

  return (
    <Container fluid className="dashboard-container">
      {/* Page Header */}
      <div className="page-header mb-4">
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <h1 className="page-title">Dashboard</h1>
            <p className="page-subtitle">
              Welcome back! Here's what's happening with your gym.
            </p>
          </div>
          <div>
            <Button
              variant="outline-secondary"
              className="me-2"
              onClick={fetchDashboardData}
            >
              Refresh
            </Button>
            <Button
              variant="success"
              onClick={() => (window.location.href = "/members/add")}
            >
              <FaUserPlus className="me-2" /> Add Member
            </Button>
            <Button
              variant="info"
              className="ms-2"
              onClick={() => (window.location.href = "/members/expiry/report")}
            >
              <FaCalendarTimes className="me-2" /> View Expiry Report
            </Button>
          </div>
        </div>
      </div>

      {error && (
        <Alert variant="danger" onClose={() => setError("")} dismissible>
          {error}
        </Alert>
      )}

      {/* Stats Cards */}
      {/* <Row className="mb-4">
        <Col xl={3} lg={6} md={6} sm={12} className="mb-3">
          <StatCard
            title="Total Members"
            value={stats.totalMembers}
            icon={FaUsers}
            color="primary"
            subtitle={`${stats.newMembersThisMonth} new this month`}
          />
        </Col>
        <Col xl={3} lg={6} md={6} sm={12} className="mb-3">
          <StatCard
            title="Active Members"
            value={stats.activeMembers}
            icon={FaCalendarCheck}
            color="success"
            subtitle={`${(
              (stats.activeMembers / stats.totalMembers) *
              100
            ).toFixed(1)}% active`}
          />
        </Col>
        <Col xl={3} lg={6} md={6} sm={12} className="mb-3">
          <StatCard
            title="Total Revenue"
            value={formatCurrency(stats.totalRevenue)}
            icon={FaDollarSign}
            color="warning"
            subtitle={`${formatCurrency(stats.pendingPayments)} pending`}
          />
        </Col>
        <Col xl={3} lg={6} md={6} sm={12} className="mb-3">
          <StatCard
            title="Active Plans"
            value={stats.activePlans}
            icon={FaChartLine}
            color="info"
            subtitle={`${formatCurrency(stats.totalPaid)} collected`}
          />
        </Col>
      </Row> */}
      {/* Stats Cards */}
      <Row className="mb-4">
        <Col xl={2} lg={4} md={4} sm={6} className="mb-3">
          <StatCard
            title="Total Members"
            value={stats.totalMembers}
            icon={FaUsers}
            color="primary"
            subtitle={`${stats.newMembersThisMonth} new this month`}
          />
        </Col>
        <Col xl={2} lg={4} md={4} sm={6} className="mb-3">
          <StatCard
            title="Active Members"
            value={stats.activeMembers}
            icon={FaCalendarCheck}
            color="success"
            subtitle={`${
              stats.totalMembers > 0
                ? ((stats.activeMembers / stats.totalMembers) * 100).toFixed(1)
                : 0
            }% active`}
          />
        </Col>
        <Col xl={2} lg={4} md={4} sm={6} className="mb-3">
          <StatCard
            title="Total Revenue"
            value={formatCurrency(stats.totalRevenue)}
            icon={FaDollarSign}
            color="warning"
            subtitle={`${formatCurrency(stats.pendingPayments)} pending`}
          />
        </Col>
        <Col xl={2} lg={4} md={4} sm={6} className="mb-3">
          <StatCard
            title="Active Plans"
            value={stats.activePlans}
            icon={FaChartLine}
            color="info"
            subtitle={`${formatCurrency(stats.totalPaid)} collected`}
          />
        </Col>
        <Col xl={2} lg={4} md={4} sm={6} className="mb-3">
          <StatCard
            title="Expiring This Month"
            value={expiringThisMonth.length}
            icon={FaExclamationTriangle}
            color="danger"
            subtitle={`${
              expiringThisMonth.filter((p) => p.daysLeft <= 7).length
            } urgent`}
            prefix=""
          />
        </Col>
        <Col xl={2} lg={4} md={4} sm={6} className="mb-3">
          <StatCard
            title="Collection Rate"
            value={`${
              stats.totalRevenue > 0
                ? ((stats.totalPaid / stats.totalRevenue) * 100).toFixed(1)
                : 0
            }%`}
            icon={FaMoneyBillWave}
            color="secondary"
            subtitle={`${formatCurrency(stats.totalPaid)} / ${formatCurrency(
              stats.totalRevenue
            )}`}
            prefix=""
          />
        </Col>
      </Row>

      {/* Charts Section */}
      <Row className="mb-4">
        <Col lg={8} md={12} className="mb-4">
          <Card>
            <Card.Header>
              <h5 className="mb-0">Revenue Overview (Last 6 Months)</h5>
            </Card.Header>
            <Card.Body>
              <div style={{ height: "300px" }}>
                <ResponsiveContainer width="100%" height="100%">
                  <BarChart data={revenueChartData}>
                    <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
                    <XAxis dataKey="month" stroke="#666" />
                    <YAxis stroke="#666" />
                    <Tooltip
                      formatter={(value) => [formatCurrency(value), "Amount"]}
                      labelFormatter={(label) => `Month: ${label}`}
                    />
                    <Legend />
                    <Bar
                      dataKey="revenue"
                      name="Total Revenue"
                      fill="#8884d8"
                      radius={[4, 4, 0, 0]}
                    />
                    <Bar
                      dataKey="paid"
                      name="Amount Collected"
                      fill="#82ca9d"
                      radius={[4, 4, 0, 0]}
                    />
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </Card.Body>
          </Card>
        </Col>

        <Col lg={4} md={12} className="mb-4">
          <Card>
            <Card.Header>
              <h5 className="mb-0">Membership Type Distribution</h5>
            </Card.Header>
            <Card.Body>
              <div style={{ height: "300px" }}>
                <ResponsiveContainer width="100%" height="100%">
                  <PieChart>
                    <Pie
                      data={membershipTypeData}
                      cx="50%"
                      cy="50%"
                      labelLine={false}
                      label={({ name, percent }) =>
                        `${name}: ${(percent * 100).toFixed(0)}%`
                      }
                      outerRadius={80}
                      fill="#8884d8"
                      dataKey="value"
                    >
                      {membershipTypeData.map((entry, index) => (
                        <Cell
                          key={`cell-${index}`}
                          fill={COLORS[index % COLORS.length]}
                        />
                      ))}
                    </Pie>
                    <Tooltip
                      formatter={(value) => [`${value} plans`, "Count"]}
                    />
                  </PieChart>
                </ResponsiveContainer>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Expiring This Month Section - NEW */}
      <Row className="mb-4">
        <Col md={12}>
          <Card>
            <Card.Header className="d-flex justify-content-between align-items-center">
              <h5 className="mb-0">
                <FaExclamationTriangle className="me-2 text-warning" />
                Plans Expiring This Month
              </h5>
              <Button
                variant="link"
                size="sm"
                onClick={() =>
                  (window.location.href = "/members/expiry/report")
                }
              >
                View Full Report
              </Button>
            </Card.Header>
            <Card.Body>
              <div className="table-responsive">
                <Table hover className="mb-0">
                  <thead>
                    <tr>
                      <th>Member</th>
                      <th>Member ID</th>
                      <th>Plan Source</th>
                      <th>Expiry Date</th>
                      <th>Days Left</th>
                      <th>Plan Amount</th>
                      <th>Pending Amount</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {expiringThisMonth.length === 0 ? (
                      <tr>
                        <td colSpan="8" className="text-center py-4">
                          <div className="text-muted">
                            <FaCalendarCheck size={32} className="mb-2" />
                            <p>No plans expiring this month</p>
                          </div>
                        </td>
                      </tr>
                    ) : (
                      expiringThisMonth.slice(0, 8).map((plan, index) => (
                        <tr key={`${plan.memberId}-${plan.source}-${index}`}>
                          <td>
                            <div className="fw-medium">{plan.memberName}</div>
                            <small className="text-muted">{plan.phone}</small>
                          </td>
                          <td>
                            <Badge bg="secondary">{plan.memberId}</Badge>
                          </td>
                          <td>{getPlanSourceBadge(plan.source)}</td>
                          <td>
                            <FaCalendar className="me-1 text-muted" />
                            {formatDate(plan.expiry_date)}
                          </td>
                          <td>{getDaysLeftBadge(plan.daysLeft)}</td>
                          <td className="fw-bold">
                            {formatCurrency(plan.total_amount || plan.amount)}
                          </td>
                          <td className="text-danger fw-bold">
                            {formatCurrency(plan.pending_amount)}
                          </td>
                          <td>
                            <span
                              className={`badge ${
                                plan.fee_status === "Paid"
                                  ? "bg-success"
                                  : plan.fee_status === "Partial"
                                  ? "bg-warning"
                                  : "bg-danger"
                              }`}
                            >
                              {plan.fee_status || "Unpaid"}
                            </span>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </Table>
              </div>
              {expiringThisMonth.length > 8 && (
                <div className="text-center mt-3">
                  <small className="text-muted">
                    Showing 8 of {expiringThisMonth.length} expiring plans
                  </small>
                </div>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
      {/* Recent Activity */}
      <Row>
        <Col lg={6} md={12} className="mb-4">
          <Card>
            <Card.Header className="d-flex justify-content-between align-items-center">
              <h5 className="mb-0">Recent Members</h5>
              <Button
                variant="link"
                size="sm"
                onClick={() => (window.location.href = "/members")}
              >
                View All
              </Button>
            </Card.Header>
            <Card.Body>
              <div className="table-responsive">
                <Table hover className="mb-0">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Member ID</th>
                      <th>Join Date</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {recentMembers.length === 0 ? (
                      <tr>
                        <td colSpan="4" className="text-center py-4">
                          <div className="text-muted">
                            <FaUsers size={32} className="mb-2" />
                            <p>No members found</p>
                          </div>
                        </td>
                      </tr>
                    ) : (
                      recentMembers.map((member) => (
                        <tr key={member.id}>
                          <td>
                            <div className="d-flex align-items-center">
                              <div className="avatar-sm bg-primary text-white rounded-circle d-flex align-items-center justify-content-center me-2">
                                {member.first_name?.[0]?.toUpperCase() || "M"}
                              </div>
                              <div>
                                <div className="fw-medium">
                                  {member.first_name} {member.last_name}
                                </div>
                                <small className="text-muted">
                                  {member.email}
                                </small>
                              </div>
                            </div>
                          </td>
                          <td>
                            <Badge bg="secondary">{member.member_id}</Badge>
                          </td>
                          <td>
                            <FaCalendar className="me-1 text-muted" />
                            {formatDate(member.created_at)}
                          </td>
                          <td>
                            <span
                              className={`badge ${
                                member.is_active ? "bg-success" : "bg-secondary"
                              }`}
                            >
                              {member.is_active ? "Active" : "Inactive"}
                            </span>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </Table>
              </div>
            </Card.Body>
          </Card>
        </Col>

        <Col lg={6} md={12} className="mb-4">
          <Card>
            <Card.Header className="d-flex justify-content-between align-items-center">
              <h5 className="mb-0">Recent Membership Plans</h5>
              <Button
                variant="link"
                size="sm"
                onClick={() => (window.location.href = "/membership/plans")}
              >
                View All
              </Button>
            </Card.Header>
            <Card.Body>
              <div className="table-responsive">
                <Table hover className="mb-0">
                  <thead>
                    <tr>
                      <th>Plan ID</th>
                      <th>Member</th>
                      <th>Amount</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {recentPlans.length === 0 ? (
                      <tr>
                        <td colSpan="4" className="text-center py-4">
                          <div className="text-muted">
                            <FaMoneyBillWave size={32} className="mb-2" />
                            <p>No plans found</p>
                          </div>
                        </td>
                      </tr>
                    ) : (
                      recentPlans.map((plan) => (
                        <tr key={plan.id}>
                          <td>
                            <div className="fw-bold">#{plan.id}</div>
                          </td>
                          <td>
                            <div>Member #{plan.member}</div>
                            <small className="text-muted">
                              Type: {plan.subscription_type}
                            </small>
                          </td>
                          <td>
                            <div className="fw-bold">
                              {formatCurrency(plan.total_amount || plan.amount)}
                            </div>
                            <div className="d-flex">
                              <small className="text-success me-2">
                                Paid: {formatCurrency(plan.paid_amount)}
                              </small>
                              <small className="text-danger">
                                Pending: {formatCurrency(plan.pending_amount)}
                              </small>
                            </div>
                          </td>
                          <td>
                            <div>
                              <span
                                className={`badge ${
                                  plan.is_active ? "bg-success" : "bg-secondary"
                                }`}
                              >
                                {plan.is_active ? "Active" : "Inactive"}
                              </span>
                              <div className="mt-1">
                                <small className="text-muted">
                                  <FaClock className="me-1" />
                                  {formatDate(plan.expiry_date)}
                                </small>
                              </div>
                            </div>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </Table>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Quick Stats */}
      <Row>
        <Col md={12}>
          <Card>
            <Card.Header>
              <h5 className="mb-0">Performance Summary</h5>
            </Card.Header>
            <Card.Body>
              <Row>
                <Col md={3}>
                  <div className="mb-3">
                    <div className="d-flex justify-content-between mb-1">
                      <span className="text-muted">
                        <FaUsers className="me-1" /> Member Growth
                      </span>
                      <span className="fw-bold">
                        {stats.newMembersThisMonth} new
                      </span>
                    </div>
                    <ProgressBar
                      now={Math.min(
                        (stats.newMembersThisMonth / 50) * 100,
                        100
                      )}
                      variant="success"
                    />
                  </div>
                </Col>
                <Col md={3}>
                  <div className="mb-3">
                    <div className="d-flex justify-content-between mb-1">
                      <span className="text-muted">
                        <FaDollarSign className="me-1" /> Collection Rate
                      </span>
                      <span className="fw-bold">
                        {stats.totalRevenue > 0
                          ? (
                              (stats.totalPaid / stats.totalRevenue) *
                              100
                            ).toFixed(1)
                          : 0}
                        %
                      </span>
                    </div>
                    <ProgressBar
                      now={
                        stats.totalRevenue > 0
                          ? (stats.totalPaid / stats.totalRevenue) * 100
                          : 0
                      }
                      variant="primary"
                    />
                  </div>
                </Col>
                <Col md={3}>
                  <div className="mb-3">
                    <div className="d-flex justify-content-between mb-1">
                      <span className="text-muted">
                        <FaChartLine className="me-1" /> Active Rate
                      </span>
                      <span className="fw-bold">
                        {stats.totalMembers > 0
                          ? (
                              (stats.activeMembers / stats.totalMembers) *
                              100
                            ).toFixed(1)
                          : 0}
                        %
                      </span>
                    </div>
                    <ProgressBar
                      now={
                        stats.totalMembers > 0
                          ? (stats.activeMembers / stats.totalMembers) * 100
                          : 0
                      }
                      variant="warning"
                    />
                  </div>
                </Col>
                <Col md={3}>
                  <div className="mb-3">
                    <div className="d-flex justify-content-between mb-1">
                      <span className="text-muted">
                        <FaCalendarCheck className="me-1" /> Plan Utilization
                      </span>
                      <span className="fw-bold">
                        {stats.totalMembers > 0
                          ? (
                              (stats.activePlans / stats.totalMembers) *
                              100
                            ).toFixed(1)
                          : 0}
                        %
                      </span>
                    </div>
                    <ProgressBar
                      now={
                        stats.totalMembers > 0
                          ? (stats.activePlans / stats.totalMembers) * 100
                          : 0
                      }
                      variant="info"
                    />
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Dashboard;
